export const isIOS = (navigator: Navigator) =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  !(typeof window !== 'undefined' && window.MSStream);

export const isIPadDevice = (navigator: Navigator) =>
  navigator.userAgent.includes('iPad') ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const isSafariBrowser = (navigator: Navigator) =>
  /(iPad|iPhone|iPod|Macintosh)/.test(navigator.userAgent) &&
  navigator.userAgent.includes('Safari') &&
  !navigator.userAgent.includes('Chrome') &&
  !navigator.userAgent.includes('Firefox') &&
  !navigator.userAgent.includes('Edg') &&
  !(typeof window !== 'undefined' && window.MSStream);

export const isFirefoxBrowser = (navigator: Navigator) =>
  navigator.userAgent.includes('Firefox');

export const isAndroidDevice = (navigator: Navigator) =>
  /Android/i.test(navigator.userAgent);

export const isAutoplayAudioRestricted = (navigator: Navigator) =>
  isIOS(navigator) || isSafariBrowser(navigator) || isFirefoxBrowser(navigator);

/**
 * Utility to extract all platform check values for the current device.
 * @returns empty object on SSR, otherwise object with platform check values.
 */
export const getDevicePlatformInfo = () => {
  if (typeof window === 'undefined') return {};
  const { navigator } = window;

  const isIOSDevice = isIOS(navigator);
  const isIPad = isIPadDevice(navigator);
  const isSafari = isSafariBrowser(navigator);
  const isFirefox = isFirefoxBrowser(navigator);
  const isAndroid = isAndroidDevice(navigator);
  const autoplayAudioRestricted = isAutoplayAudioRestricted(navigator);
  const isIPadChrome = isIPad && /CriOS/i.test(navigator.userAgent);

  return {
    isIOS: isIOSDevice,
    isIPad,
    isSafari,
    isFirefox,
    isAndroid,
    isIPadChrome,
    autoplayAudioRestricted,
  };
};
